var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProgramTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    stroke: "none",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 7C1.2 3.79675 3.79675 1.2 7 1.2C7.77468 1.2 8.51246 1.35155 9.18643 1.62607C9.49332 1.75107 9.84344 1.60362 9.96844 1.29673C10.0934 0.989841 9.94599 0.639725 9.6391 0.514724C8.82386 0.182665 7.93252 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 6.74503 13.9863 6.49304 13.9597 6.24476C13.9243 5.91528 13.6285 5.67687 13.299 5.71225C12.9696 5.74763 12.7312 6.0434 12.7665 6.37288C12.7886 6.57869 12.8 6.78792 12.8 7C12.8 10.2033 10.2033 12.8 7 12.8C3.79675 12.8 1.2 10.2033 1.2 7ZM14.2243 2.02428C14.4586 1.78996 14.4586 1.41006 14.2243 1.17575C13.9899 0.941433 13.61 0.941434 13.3757 1.17575L6.99999 7.5515L5.42426 5.97576C5.18994 5.74145 4.81004 5.74145 4.57573 5.97576C4.34141 6.21008 4.34141 6.58997 4.57573 6.82429L6.57573 8.82429C6.68825 8.93681 6.84086 9.00002 6.99999 9.00002C7.15912 9.00002 7.31174 8.93681 7.42426 8.82429L14.2243 2.02428Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgramTask);
export default __webpack_public_path__ + "static/media/icon-program-task.0facd080a51586668fcce52a791c239c.svg";
export { ForwardRef as ReactComponent };